export const commitmentRes = [{
  
    callbackId: 101,
   
    target: "inknown",
   
    agentId: 63362,
   
    skillId: 676338,
   
    dialNumber: "537527372",
  
    origNumber: "64337",
   
    firstName: "Paul",
    
    lastName: "Strling",
   
    notes: "Test Commitment for agent Paul",
   
    callbackTime: new Date(Date.now()),
  }];